export enum SkillLevelValidationStatus {
    VALIDATED = "validated",
    UNVALIDATED = "unvalidated",
    NOT_EVALUATED = "notEvaluated",
}
